import { updateAllData } from './';
import { collectChapters, distributeChapters } from './updatePhaseDetails';
import { rebuildSubjectsArray } from './addNewMilestone';
interface NewDetailsType {
  name: string;
  startDate: Date;
  endDate: Date;
}

export const moveSyllabus = (tree: any, setTreeData: Function, phaseIndex: number, newDetails: NewDetailsType) => {
  const cloneTree = JSON.parse(JSON.stringify(tree));
  const { phases } = tree;
  let clonePhases = JSON.parse(JSON.stringify(phases));
  const currentPhase = clonePhases[phaseIndex];
  currentPhase.conflict = false;
  //get index of next non-revision phase
  const index = getIndexOfNextNonRevisionPhase(phaseIndex, phases);
  const nextPhase = clonePhases[index];

  updateCurrentPhaseWithNewDetails(currentPhase, newDetails);

  const currentPhaseSyllabus = collectChapters(currentPhase.weeks);
  //remove subjects from revision phase
  removeSubjectsFromWeeks(currentPhase.weeks);
  if (nextPhase) {
    const nextPhaseSyllabus = collectChapters(nextPhase.weeks);

    const combinedSyllabus = combineSyllabus(currentPhaseSyllabus, nextPhaseSyllabus);

    // prepare new weeks for next phase
    removeSubjectsFromWeeks(nextPhase.weeks);
    let newWeeks = JSON.parse(JSON.stringify(nextPhase.weeks));

    //add syllabus to next non-Revision phase
    newWeeks = distributeChapters(newWeeks, combinedSyllabus);
    nextPhase.weeks = JSON.parse(JSON.stringify(newWeeks));
  }

  rebuildSubjectsArray(currentPhase);
  rebuildSubjectsArray(clonePhases[index]);

  // updateAllData(tree, clonePhases, setTreeData);
      cloneTree.phases = clonePhases;
      // updateAllData(tree, clonePhases, setTreeData);
      setTreeData({ treeData: cloneTree  });
};

export const removeSubjectsFromWeeks = (weeks: any) => {
  for (const week of weeks) {
    week.subjects = [];
  }
};

export const combineSyllabus = (prevSyllabus: any, nextSyllabus: any) => {
  const combinedSyllabus: any = [];

  for (const subject of prevSyllabus) {
    for (const sub of nextSyllabus) {
      if (subject.name === sub.name) {
        subject.chapters = [...subject.chapters, ...sub.chapters];
        // const index = nextSyllabus.indexOf(sub);
        // nextSyllabus.splice(index, 1);
      }
    }
    combinedSyllabus.push(JSON.parse(JSON.stringify(subject)));
    // const index = prevSyllabus.indexOf(subject);
    // prevSyllabus.splice(index, 1);
  }

  // remove subjects from nextSyllabus array which have already been added
  for (const sub of combinedSyllabus) {
    let index = -1;
    for (let i = 0; i < nextSyllabus.length; i++) {
      if (sub.name === nextSyllabus[i].name) {
        index = i;
      }
    }
    if (index !== -1) {
      nextSyllabus.splice(index, 1);
    }
  }

  //if subjects are left in nextSyllabus array add them
  if (nextSyllabus.length) {
    for (const subject of nextSyllabus) {
      combinedSyllabus.push(JSON.parse(JSON.stringify(subject)));
    }
  }
  return combinedSyllabus;
};

const getIndex = (phase: any, subjectName: string) => {
  const subjects = phase.subjects;
  for (let i = 0; i < subjects.length; i++) {
    if (subjects[i].name === subjectName) return i;
  }
  return -1;
};

export const updateSubjectsArray = (phase: any) => {
  phase.subjects.forEach((subject: any) => {
    subject.chapterCount = 0;
  });
  phase.weeks.forEach((week: any) => {
    week.subjects.forEach((subject: any) => {
      let index = getIndex(phase, subject.name);
      if (index === -1) {
        phase.subjects.push({
          name: subject.name,
          id: subject.id,
          chapterCount: subject.chapters.length,
        });
      } else {
        phase.subjects[index].chapterCount += subject.chapters.length;
      }
    });
  });
};

const updateCurrentPhaseWithNewDetails = (currentPhase: any, newDetails: NewDetailsType) => {
  currentPhase.name = newDetails.name;
  currentPhase.startDate = newDetails.startDate;
  currentPhase.endDate = newDetails.endDate;
  currentPhase.isRevision = true;
};

const updateChapterCount = (currentPhase: any) => {
  currentPhase.subjects.forEach((subject: any) => {
    subject.chapterCount = 0;
  });
};

export const getIndexOfNextNonRevisionPhase = (phaseIndex: number, phases: any) => {
  let index = phaseIndex + 1;
  while (index < phases.length && phases[index].isRevision) {
    index++;
  }
  return index;
};

export const removeSyllabus = (currentPhase: any) => {
  // let weekData: any = [];
  let { weeks } = currentPhase;
  const weekData = JSON.parse(JSON.stringify(weeks));
  for (const week of weeks) {
    week.subjects = [];
    week.content = [];
  }
  return weekData;
};

export const addSyllabusToNextPhase = (clonePhases: any, index: number, syllabus: any) => {
  const nextPhase = clonePhases[index];
  let minWeeksLength = Math.min(syllabus.length, nextPhase.weeks.length);
  if (minWeeksLength > 0) {
    for (let i = 0; i < minWeeksLength; i++)
      while (syllabus[i].subjects.length) {
        const subName = syllabus[i].subjects[0].name;
        const index = getIndexOfSubjectInNextPhase(nextPhase.weeks[i].subjects, subName);
        if (index === -1) {
          nextPhase.weeks[i].subjects.push(syllabus[i].subjects[0]);
        } else {
          nextPhase.weeks[i].subjects[index].chapters = [
            ...nextPhase.weeks[i].subjects[index].chapters,
            ...syllabus[i].subjects[0].chapters,
          ];
        }
        syllabus[i].subjects.splice(0, 1);
      }
  }
  if (syllabus.length > nextPhase.weeks.length) {
    syllabus.splice(0, minWeeksLength - 1); //remove previous weeks
    nextPhase.weeks = [...nextPhase.weeks, ...syllabus];
  }
};

export const getIndexOfSubjectInNextPhase = (subjects: any, subName: string) => {
  for (let i = 0; i < subjects.length; i++) {
    if (subjects[i].name === subName) return i;
  }
  return -1;
};

const addNewPhaseWithSyllabus = (clonePhases: any, index: number, syllabus: any) => {
  const revisionPhase = clonePhases[index];
  const newPhase = JSON.parse(JSON.stringify(revisionPhase));
  newPhase.name = `New ${revisionPhase.name}`;
  newPhase.isRevision = false;
  newPhase.weeks = JSON.parse(JSON.stringify(syllabus));
  clonePhases.push(newPhase);
};

const updateWeekNumbers = (clonePhases: any) => {
  let num = 0;
  clonePhases.forEach((phase: any) => {
    if (phase.weeks && phase.weeks.length) {
      phase.weeks.forEach((week: any) => {
        week.weekNo = ++num;
      });
    }
  });
};

const updateCurrentPhaseWeeksData = (currentPhase: any) => {
  for (const week of currentPhase.weeks) {
    week.subject = [];
    week.content = [];
  }
};
